module.exports = __webpack_public_path__ + "img/logo.351d7d48.png";